import React from "react";
import { PaperClipIcon } from "@heroicons/react/20/solid";
import { Button } from "@mantine/core";

type Props = {
  textToCopy: string,
};

const CopyButton = ({ textToCopy }: Props) => (
  <div className="relative">
    <Button
      variant="light"
      size="xs"
      leftSection={<PaperClipIcon className="h-4 w-4" />}
      onClick={() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        navigator.clipboard.writeText(textToCopy);
      }}
    >Copy</Button>
  </div>
);

export default CopyButton;
